/**
 * API Configuration
 */

const apiConfig = {
  // Base URL for API
  baseURL: process.env.REACT_APP_API_URL || 'https://api.loga.hr/api',

  // Timeout for API requests (in milliseconds)
  timeout: 10000,

  // Endpoints
  endpoints: {
    contact: '/contact',
    health: '/health',
  },

  // Headers
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

/**
 * Get full API URL for endpoint
 */
export const getApiUrl = (endpoint) => {
  return `${apiConfig.baseURL}${endpoint}`;
};

/**
 * Validate API configuration
 */
export const validateApiConfig = () => {
  const warnings = [];

  if (!apiConfig.baseURL) {
    warnings.push('⚠️  API Base URL not configured');
  }

  if (warnings.length > 0) {
    console.warn('API Configuration Warnings:');
    warnings.forEach(warning => console.warn(warning));
  }

  return warnings.length === 0;
};

export default apiConfig;